import { createPortal } from "react-dom";
import channelLogo from "../../assets/kakao/kakao-channel-symbol.svg";
import "./KakaoInquiryLink.css";

export function KakaoInquiryLink() {
  return createPortal(
    <a
      className="public-kakao-inquiry"
      href="https://pf.kakao.com/_pUhfX"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="카카오톡 문의 · 새 창에서 열림"
    >
      <img src={channelLogo} width="20" height="22" alt="" aria-hidden="true" />
      <span>카카오톡 문의</span>
    </a>,
    document.body,
  );
}
